import { render, staticRenderFns } from "./SaldoBalance.vue?vue&type=template&id=5cca960e&scoped=true"
import script from "./SaldoBalance.vue?vue&type=script&lang=js"
export * from "./SaldoBalance.vue?vue&type=script&lang=js"
import style0 from "./SaldoBalance.vue?vue&type=style&index=0&id=5cca960e&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5cca960e",
  null
  
)

export default component.exports